export enum DELIVERED_BY {
  VANDEMMIA = 'Vendemmia',
}
